import React, { useEffect, useState } from "react";
import "./styles.css";
import { backgroundHiepHoi, logoHiepHoi } from "../../assets/images";
import Form1 from "./form1";
import { useLocation, useHistory } from "react-router-dom";
import Form2 from "./form2";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const HiepHoiDoanhNghiep = () => {
  const [showDialog, setShowDialog] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const query = useQuery();
  const type = query.get("type"); // lấy giá trị của type
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    document.title = "Hiệp Hội Doanh Nghiệp";
    const fetchData = async (type = 0) => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_CRM_ENDPOINT_URL}/vi/api/v1.0/CustomerPortal/HiepHoiDoanhNghiep/danh-muc/${process.env.REACT_APP_SECRETKEY}?type=${type}`
        );
        const json = await res.json();
        setCompanies(json.data);
      } catch (error) {
        console.error("Lỗi fetch:", error);
      } finally {
      }
    };

    if (type) {
      fetchData(type);
    }
  }, [type]);

  useEffect(() => {
    if (!type) {
      // Nếu không có type trong URL thì redirect thêm ?type=1
      history.replace(
        {
          pathname: location.pathname,
          search: "?type=1",
        },
        { replace: true }
      );
    }
  }, [type, location.pathname, history]);

  if (!type) {
    // Đợi redirect hoặc render gì đó khi chưa có type
    return null;
  }

  return (
    <div
      className="App"
      style={{
        backgroundImage: `url(${backgroundHiepHoi})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: "center",
        color: "white",
      }}
    >
      {/* Header */}
      <header
        style={{
          width: "100%",
          padding: "20px 0 10px 0",
          background: "rgba(0, 0, 0, 0.3)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src={logoHiepHoi}
          alt="HTBA logo"
          style={{ width: "120px", marginBottom: "10px" }}
        />
        <h2 style={{ margin: 0, fontSize: "18px" }}>
          Hiệp Hội Doanh Nghiệp Xã Hoàng Thanh
        </h2>
      </header>

      {/* Nội dung chính */}
      <main
        style={{
          flex: 1,
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {type === "1" && (
          <Form1 companies={companies} setShowDialog={setShowDialog} />
        )}
        {type === "2" && (
          <Form2 companies={companies} setShowDialog={setShowDialog} />
        )}
      </main>

      {/* Footer */}
      <footer
        style={{
          width: "100%",
          padding: "10px 0",
          background: "rgba(0,0,0,0.3)",
          fontSize: "14px",
        }}
      >
        © 2025 Meditech
      </footer>

      {/* Dialog cảm ơn */}
      {showDialog && (
        <div className="thankyou-overlay">
          <div className="thankyou-dialog">
            <h2>Cảm ơn bạn!</h2>
            <p>Thông tin đã được gửi thành công.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default HiepHoiDoanhNghiep;
